import mainLogo from "../images/Logo/main-logo.webp";
import loggedInLogo from "../images/Logo/loggedInLogo.webp";
import mainLogoWhite from "../images/Logo/main-logo-white.webp";
import carousel1 from "../images/Carousel/carousel1.jpeg";
import carousel2 from "../images/Carousel/carousel2.jpeg";

export const stylesConfig = {
  mainLogo: mainLogo,
  loggedInLogo: loggedInLogo,
  mainLogoWhite: mainLogoWhite,
  carouselImages: [carousel1, carousel2, carousel1],
};
